import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterReducerState as _RouterReducerState } from '@ngrx/router-store';
import { Action, ActionReducer, createAction, createFeatureSelector, createSelector } from '@ngrx/store';


export const clearState = createAction('[App] Clear state');
export const toggleNotifications = createAction('[App] Toggle notifications');


export function clearStateMetaReducer<T, V extends Action>(reducer: ActionReducer<T, V>): ActionReducer<T, V> {
    return (state, action) => {
        if (action.type === clearState.type) {
            state = undefined;
        }
        return reducer(state, action);
    };
}


// state in RouterReducerState can be null e.g. when navigating to /#/login
type RouterReducerState = _RouterReducerState | { state: null };


export const selectRouter = createFeatureSelector<RouterReducerState>('router');

const hasOutlet = (children: ActivatedRouteSnapshot[], outlet: string) => children.some(c => c.outlet === outlet);

export const getNotificationsDropdownState = createSelector(
    selectRouter,
    state => state && state.state && hasOutlet(state.state.root.children, 'notifications')
);
